import wrapArrayIfNeeded from "../../../utils/wrapArrayIfNeeded";

const CHANGE_ENABLED = "type:CHANGE_ENABLED";

export const actionTypes = {
  CHANGE_ENABLED
};

// So far, it is used for V2 readonly
const changeEnabled = (ids, enabled) => {
  return {
    type: CHANGE_ENABLED,
    ids: wrapArrayIfNeeded(ids),
    enabled
  };
};

export default {
  changeEnabled
};
